<template lang="pug">
  .easyparcel
    v-layout.my-6(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

    .contain-layout(v-else)

      .main-layout(v-if="!action")
        v-container(style="max-width:600px").px-7
          v-layout.my-4
            v-row.fill-height.ma-0(align='center' justify='center' @click="action = null" style="cursor: pointer;")
              div.mx-auto
                v-img.mx-auto(:src="require('@/assets/images/logo_lalamove.png')" style="width:240px" contain)

          v-btn.mt-10.button-AA-medium.white--text.info500(block outlined @click="action = 'setup-account'") setup account
            v-icon(v-if="settings.setup" right color="white") mdi-check-circle-outline
      .action-layout(v-else)
        v-layout.mb-14.mt-2.mx-4
          div.mr-4
            v-icon(left color="black" :size="20" @click="action = null") mdi-arrow-left
          div.h6.mt-1 Lalamove Setup
        setup-lalamove(v-if="action == 'setup-account'" :company="company")
</template>

<script>
import SetupLalamove from '@/views/admin/settings/SetupLalamove.vue'

export default {
  name: 'Lalamove',
  components: { 
    SetupLalamove,
    },
  props: ['company'],
  data: () => ({
    isFetching: true,
    settings: {
      setup: false,
      activated: false
    },
    action: null
  }),
  mounted () {
    this.fetchSettings()
  },
  methods: {
    gotoActivate () {
      this.$router.push('/admin/settings/shipping')
    },
    fetchSettings () {
      this.$axios.get(`/shipping/settings/${this.company.slug}/lalamove`)
      .then(() => {
          this.settings.setup = true
      })
      .catch(()=>{
      })
      .finally(()=>{
        this.isFetching = false
      })

      this.$axios.get(`/invoice_settings/?company=${this.company.id}`).then((response) => {
        if (response.data.results.length != 0) {
          const invoiceSettings = response.data.results[0]
          if (invoiceSettings.extra_settings) {
            const shippingMethod = invoiceSettings.extra_settings.shipping_method
            if (shippingMethod === 'lalamove') {
              this.settings.activated = true
            }
          }
        }
      }).catch(() => {})
    },
  }
}
</script>
